import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import ManagedAccountPortfolioLegacy
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/BalanceAndAllocationTabPanelLayout/ManagedAccountPortfolioLegacy';
import ManagedAccountPortfolioWithGroups
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/BalanceAndAllocationTabPanelLayout/ManagedAccountPortfolioWithGroups';

export default function ManagedAccountPortfolio({ portfolio }) {
  if (!portfolio) {
    return null;
  }
  return portfolio.withRelationship(fr.relationships.holdingsGroup.name,
    () => <ManagedAccountPortfolioWithGroups portfolio={portfolio} />,
    () => <ManagedAccountPortfolioLegacy portfolio={portfolio} />);
}
ManagedAccountPortfolio.defaultProps = {
  portfolio: undefined,
};
ManagedAccountPortfolio.propTypes = {
  portfolio: PropTypes.instanceOf(fr.Resource),
};
